export default "__VITE_ASSET__CZ7AbSEC__"